import { createContext, useContext } from 'react';

export type AppSettings = {
  appVersion: string;
  sentryEnvironment: string;
  oidc: {
    authority: string;
    client_id: string;
  };
};

export const defaultAppSettings: AppSettings = {
  appVersion: '',
  sentryEnvironment: '',
  oidc: {
    authority: '',
    client_id: '',
  },
};

export const AppSettingsContext = createContext<AppSettings>(defaultAppSettings);

export const useAppSettingsContext = () => {
  return useContext(AppSettingsContext);
};
